module.exports = __webpack_public_path__ + "static/media/test2_4.4e245125.png";